import kycSourcedReportTypes from './kyc-sourced-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// FETCH KYC SOURCED REPORT DETAILS
	getKYCSourcedDetailResponse: null,
	getKYCSourcedDetailArr: [],
};

const kycSourcedReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH KYC SOURCED REPORT DETAILS START *********************** */
		case kycSourcedReportTypes.GET_KYC_SOURCED_REPORT_SUCCESS:
			return {
				...state,
				getKYCSourcedDetailResponse: action.payload,
				getKYCSourcedDetailArr: docodeHexResponse(
					action.payload,
					'KYCSourcedReportDetailsKey',
				),
			};

		case kycSourcedReportTypes.GET_KYC_SOURCED_REPORT_FAILURE:
			return { ...state, getKYCSourcedDetailResponse: action.payload };

		case kycSourcedReportTypes.GET_KYC_SOURCED_REPORT_RESPONSE_CHANGED:
			return { ...state, getKYCSourcedDetailResponse: null };
		/** ***************** FETCH KYC SOURCED REPORT DETAILS END *********************** */

		default:
			return state;
	}
};

export default kycSourcedReportReducer;
